// Share a small loading budget across map pins. Cancelling releases its slot.
export const createImageQueue = (limit = 4, makeImage = () => new Image()) => {
  const waiting = [];
  let active = 0;
  const pump = () => {
    while (active < limit && waiting.length) {
      const job = waiting.shift();
      if (job.cancelled) continue;
      active += 1;
      job.image = makeImage();
      job.finish = (success) => {
        if (job.finished) return;
        job.finished = true;
        job.image.onload = null;
        job.image.onerror = null;
        clearTimeout(job.timer);
        active -= 1;
        if (!success) job.image.removeAttribute("src");
        if (!job.cancelled) job.callback(success);
        pump();
      };
      job.image.onload = () => job.finish(true);
      job.image.onerror = () => job.finish(false);
      job.timer = setTimeout(() => job.finish(false), 20000);
      job.image.src = job.src;
    }
  };
  return (src, callback) => {
    const job = { src, callback };
    waiting.push(job);
    pump();
    return () => {
      job.cancelled = true;
      if (job.finish) job.finish(false);
      else {
        const index = waiting.indexOf(job);
        if (index >= 0) waiting.splice(index, 1);
      }
    };
  };
};

export const loadMapImage = createImageQueue();
